import { ILeadRepository } from '../../../domain/repositories/ILeadRepository';
import { Lead } from '../../../domain/entities/Lead';

export class GetLeadsUseCase {
    constructor(private leadRepository: ILeadRepository) { }

    async execute(funnelId?: string, organizationId?: string): Promise<Lead[]> {
        if (funnelId) {
            return await this.leadRepository.findByFunnel(funnelId, organizationId);
        }
        return await this.leadRepository.findAll(organizationId);
    }
}
